import {ListaDocentes as Matricula} from 'containers/Admin/ListaDocentes'

export default function ListaDocentes() {
  return (
    <Matricula />
  );
}
